<div class="flex flex-row gap-2">
	@for (index of indexRange(); track index) {
		<button
			class="w-8 h-3 rounded-xl transition-colors"
			[class.bg-secondary-500]="index === currentSlideIndex()"
			[class.bg-secondary-300]="index !== currentSlideIndex()"
			[class.hover:bg-secondary-400]="index !== currentSlideIndex()"
			(click)="onClick(index)"
		></button>
	}
</div>
